export default {"src":"/_next/static/media/cart-gray.abab88ab.svg","height":20,"width":25};